import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PayAsYouGoKeyLimitBanner = lazy(() => import('.'))

const RootProviders = lazy(() => import('@app/components/AppProviders'))

class PayAsYouGoKeyLimitBannerWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['key-limit', 'key-count', 'team-uuid']
  }

  override render() {
    const keyLimit = Number(this.prop('key-limit'))
    const keyCount = Number(this.prop('key-count'))
    const teamUuid = this.prop('team-uuid')

    return (
      <RootProviders>
        <PayAsYouGoKeyLimitBanner keyLimit={keyLimit} keyCount={keyCount} teamUuid={teamUuid} />
      </RootProviders>
    )
  }
}

customElements.define('pay-as-you-go-key-limit-banner', PayAsYouGoKeyLimitBannerWebComponent)
